import { Component, OnInit, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../_services';
import { DateUtilsService } from '../../_services/dateUtils';
import { FilterService } from '../../_services/filter.service';
import { Config } from '../../_store';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';
  readonly DT_FORMAT = 'DD-MMM-YYYY';
  private monthDict = { '1': 'Jan', '2': 'Feb', '3': 'Mar', '4': 'Apr', '5': 'May', '6': 'Jun', '7': 'Jul', '8': 'Aug', '9': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec' };
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    let formateDate
    if(date){
      if(date.day <= 9 && date.month <=9){
          formateDate = '0'+date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day <= 9 && date.month >= 10 ){
          formateDate = '0'+date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day >= 10 && date.month <=9 ){
          formateDate = date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
      if(date.day >= 10 && date.month >= 10 ){
          formateDate = date.day + this.DELIMITER + this.monthDict[date.month] + this.DELIMITER + date.year
      }
    }
    else{
      formateDate = '';
    }
    return formateDate
  }
}

@Component({
  selector: 'app-filters',
  templateUrl: './app-filters.component.html',
  // providers: [
  //   {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  // ]
})
export class AppFiltersComponent implements OnInit {
  @Input() itemList: any;
  @Input() itemFilters: any;
  @Output() onFiltersApplied = new EventEmitter();
  @Output() onDistributorInfoClicked = new EventEmitter();
  @Output() onPreFiltersApplied = new EventEmitter();
  predefinedFilter :any;
  
  // variable declare for filter
   visible = false;

  todaysDate = this.dateUtilsService.getToday().format(Config.dateSaveFormat);
  filterModal:any = {};
  minDate = undefined;
  maxDate = undefined;
  constructor(private filterService: FilterService, private dateUtilsService: DateUtilsService,  public activeModal: NgbActiveModal) { 
    const current = new Date();
    this.maxDate = {
      day: current.getDate(),
      month: current.getMonth() + 1,
      year: current.getFullYear()
    };
    this.minDate = {
      day: current.getDate(),
      month: current.getMonth() + 1,
      year: current.getFullYear()
    };
  }

  applyFilters(config, filter, rule) {
    if (filter && filter.resetFilters && !rule.applied) {
      this.filterService.resetFilters(this.itemList, config);
    }
    this.filterService.applyFilters(this.itemList, this.itemFilters, rule);
    if (this.onFiltersApplied) {
      this.onFiltersApplied.emit(this.itemFilters.appliedRules);
    }
  }

  visibleFun(){
    this.visible = true;
  }

  resetFilters() {
    this.filterService.resetFilters(this.itemList, this.itemFilters);
    this.visible=false;
  }

  close(){
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.predefinedFilter = this.filterService.getNavFilters();
    this.filterService.clearNavFilters();
    if(this.predefinedFilter.filter){
      this.doPredefined();
    }
  }
  doPredefined(){
    this.itemFilters.config.forEach(element => {
      if(element.filterLabel===this.predefinedFilter.filter){
        if(this.predefinedFilter.rule){
          element.rules.forEach(rule => {
           if(rule.label=== this.predefinedFilter.rule){
            rule.applied = !rule.applied
            this.applyFilters(this.itemFilters,element,rule);
           }
          });
        }else {
          element.rules[0].applied = !element.rules[0].applied
          this.applyFilters(this.itemFilters,element,element.rules[0]);
        }
        this.visibleFun();
        return;
      }  
    });
  }

  processOtherDataFn(rule) {
    if (this.onDistributorInfoClicked) {
      this.onDistributorInfoClicked.emit(rule.otherData);
    }
  }

  private verifyFilterDates(rule, dateSelected) {
    rule.fromCreateDate = this.dateUtilsService.getDateFromBootStrapDate(rule.fromCreateDate);
    rule.toCreateDate = this.dateUtilsService.getDateFromBootStrapDate(rule.toCreateDate);
    rule.fromCreateDate = this.dateUtilsService.getFormattedDateForDisplay(rule.fromCreateDate);
    rule.toCreateDate = this.dateUtilsService.getFormattedDateForDisplay(rule.toCreateDate);
    const dateDiff = this.dateUtilsService.getDateDiff(rule.fromCreateDate, rule.toCreateDate);
    if (dateDiff > 0) {
      if (dateSelected === 'from') {
        rule.toCreateDate = this.dateUtilsService.cloneDate(rule.fromCreateDate);
      } else {
        rule.fromCreateDate = this.dateUtilsService.cloneDate(rule.toCreateDate);
      }
    }
  }

  applyFiltersForCreateDate(rule, dateSelected) {
    rule.toCreateDate = this.filterModal.toCreateDate;
    rule.fromCreateDate = this.filterModal.fromCreateDate;
    switch (dateSelected) {
      case 'from':
        if (rule.toCreateDate) {
          this.verifyFilterDates(rule, dateSelected);
        }
        break;
      case 'to':
        if (rule.fromCreateDate) {
          this.verifyFilterDates(rule, dateSelected);
        }
        break;
      default:
        break;
    }
    if (rule.toCreateDate && rule.fromCreateDate) {
      this.applyFilters(undefined, undefined, undefined);
      //this.filterService.applyFilters(this.itemList, this.itemFilters, rule);
    }
  }

  openfilterDateControl(dateCntrl) {
    dateCntrl.open();
  }

  clearFilters() {

  }

  clearCreateDateFilters(filter) {
    const rule = filter.rules[0];
    rule.fromCreateDate = undefined;
    rule.toCreateDate = undefined;
    this.filterModal = {};
    this.filterService.applyFilters(this.itemList, this.itemFilters, undefined);
  }

  onDateSelection(date: NgbDate) {
    // this.filterModal.toCreateDate = '';
    const current = new Date();
    this.minDate = {
      day: current.getDate(),
      month: current.getMonth() + 1,
      year: current.getFullYear()
    };
    this.minDate = this.filterModal.fromCreateDate;
  }

}
